export const LINE_CONTAINER_TAG_NAME = 'P'

export function createMentionLinkNode(mentionText: string, userId: string) {
  const elem = document.createElement('a') as HTMLSpanElement
  elem.appendChild(document.createTextNode(mentionText))

  elem.style.fontWeight = 'bold'
  elem.style.color = '#55a6ff'
  elem.style.cursor = 'default'

  elem.dir = 'auto'
  elem.contentEditable = 'false'
  elem.setAttribute('data-user-id', userId)

  return elem
}
